import { create } from "zustand";
import { MOCK_JOURNAL_VERSIONS } from "./mock-data";
import type { JournalVersion } from "./types";

type JournalVersionsState = {
  versions: JournalVersion[];
  setVersions: (versions: JournalVersion[]) => void;
  addVersion: (version: JournalVersion) => void;
  reset: () => void;
};

export const useJournalVersionsStore = create<JournalVersionsState>((set) => ({
  versions: MOCK_JOURNAL_VERSIONS,
  setVersions: (versions) => set({ versions }),
  addVersion: (version) =>
    set((state) => ({ versions: [...state.versions, version] })),
  reset: () => set({ versions: MOCK_JOURNAL_VERSIONS }),
}));
